import React, { useEffect, useState } from "react";
import { httpsCallable } from "firebase/functions";
import { functions } from "src/api/firebase";
import { useAuth } from "src/contexts/AuthContext";
import HomeContent from "./HomeContent";
import MyReports from "./MyReports";
import CaseSelectionPage from "../CaseSelectionPage";
import { BackendReport } from "./types/type";
import usePartnerAwareNavigate from "src/hooks/usePartnerAwareNavigate";
import { useLocation } from "react-router-dom";
import InterviewHistoryPage from "../InterviewHistoryPage";
import CompetitionDialog from "./CompetitionDialog";
import CompetitionDialogBabson from "./CompetitionDialogBabson";

const HomePage = () => {
  const { firebaseUser, userDoc } = useAuth();
  const navigate = usePartnerAwareNavigate();
  const routingLocation = useLocation();

  // Split the pathname, e.g., "/companyA/login"
  const segments = routingLocation.pathname.split("/").filter(Boolean);
  // The first segment is assumed to be the company name:
  const companyName = segments[0];

  // For your user reports
  const [userReports, setUserReports] = useState<BackendReport[]>([]);
  const [showCompetitionDialog, setShowCompetitionDialog] = useState(false);

  // Example: fetch data if userDoc is available
  const fetchData = async () => {
    if (userDoc) {
      if (!userDoc.finishSurvey) {
        navigate(`/survey`);
      }
      const getReports = httpsCallable(functions, "getReports");
      const response = await getReports({
        uid: firebaseUser?.uid,
      });

      const data = response.data as {
        success: boolean;
        data: any;
        error?: string;
      };
      if (data.success) {
        setUserReports(data.data);
      }
    }
  };

  useEffect(() => {
    fetchData();
  }, [userDoc]);

  useEffect(() => {
    // Show competition dialog for UCLA BSN and Babson BCA users
    if (companyName === "ucla-bsn" || companyName === "babson-bca") {
      setShowCompetitionDialog(true);
    }
  }, [companyName]);

  const handleCloseCompetitionDialog = () => {
    setShowCompetitionDialog(false);
    // Mark as seen so it doesn't show again
    const key = `${companyName.replace("-", "_")}_competition_seen`;
    localStorage.setItem(key, "true");
  };

  const handleEnterCompetition = () => {
    setShowCompetitionDialog(false);
    const key = `${companyName.replace("-", "_")}_competition_seen`;
    localStorage.setItem(key, "true");
    // Navigate to the competition page or section
    navigate(`/${companyName}/weekly-contest`);
  };

  return (
    <div className=" mx-auto p-6 top-16">
      <HomeContent companyName={companyName} userReport={userReports[0]} />
      {companyName === "babson-bca" ? (
        <CompetitionDialogBabson
          isOpen={showCompetitionDialog}
          onClose={handleCloseCompetitionDialog}
          onEnterCompetition={handleEnterCompetition}
        />
      ) : (
        <CompetitionDialog
          isOpen={showCompetitionDialog}
          onClose={handleCloseCompetitionDialog}
          onEnterCompetition={handleEnterCompetition}
        />
      )}
    </div>
  );
};

export default HomePage;
